import { BasicService } from "./core/basic.service";
import md5 from 'js-md5'

export class OrderService extends BasicService {
    static async orderSet(query) {
        const data = await this.http.post('/order/orderSet',query)
        return Promise.resolve(data)
    }
    static async pay(obj) {
        const newkey = Object.keys(obj).sort();
        var newObj = {};
        newObj.sign = ''
        for (var i = 0; i < newkey.length; i++) {
            newObj[newkey[i]] = obj[newkey[i]];//向新创建的对象中按照排好的顺序依次增加键值对
            newObj.sign = newObj.sign + (newkey[i] +'='+  obj[newkey[i]] + '&')
        }
        newObj.sign = newObj.sign + 'key=5e8430f49d873'
        newObj.sign = md5(newObj.sign).toUpperCase()
        const data = await this.httpapi.get('/pay/checkSign',newObj)
        console.log(data)
    }
    static async qrcode() {
        const data = await this.httpapi.post('/pay/wechatPay/')
        return Promise.resolve(data.data.code_url)
    }

    static createQrcodeForWechat(pay_order_sn, address_id) {
        return this.http.post('/order/orderWxQrCode', { pay_order_sn, address_id });
    }

    static getOrderState(order_sn) {
        return this.http.post('/order/orderPayState', {order_sn});
    }

    static getList(data) {
        return this.http.post('/order/orderList', data);
    }

    static confirmOrder(order_sn) {
        return this.http.post('/order/receiptConfirm', { order_sn });
    }

    static orderRefund(order_sn, refund_type, user_return_reason ) {
        return this.http.post('/order/orderRefund', {refund_type, order_sn, user_return_reason })
    }

    static orderRefundCargo(data) {
        return this.http.post('/order/orderRefund', data);
    }

    static queryShipping(order_sn) {
        return this.http.post('/shipping/query', { order_sn })
    }

    static shippList(data) {
        return this.http.post('/shipping/getList', data);
      }
    
    static cancelOrder(order_sn) {
        return this.http.post('/order/orderCancel', { order_sn });
    }
    // 结算时计算商品价格积分
    static async shoppingCartAccount(data) {
        return this.http.post('/order/shoppingCartAccount',data)
    }

}